import { useState, useRef, useEffect } from "react";
import { Check, ChevronsUpDown, Search } from "lucide-react";

export default function SearchSelect({ value, onValueChange, options, placeholder = "Pilih", testId, className = "h-10" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  const sel = options.find((o) => o.value === value);
  const filtered = q ? options.filter((o) => o.label.toLowerCase().includes(q.toLowerCase())) : options;
  return (
    <div className="relative" ref={ref}>
      <button type="button" onClick={() => setOpen((v) => !v)} data-testid={testId}
        className={`w-full flex items-center justify-between gap-2 rounded-md border border-slate-200 dark:border-[#3A3A3C] bg-white dark:bg-[#1C1C1E] px-3 text-sm ${className} ${sel ? "text-slate-900 dark:text-white" : "text-slate-400"}`}>
        <span className="truncate">{sel ? sel.label : placeholder}</span>
        <ChevronsUpDown className="w-4 h-4 text-slate-400 shrink-0" />
      </button>
      {open && (
        <div className="absolute z-30 mt-1 w-full bg-white dark:bg-[#1C1C1E] border border-slate-200 dark:border-[#3A3A3C] rounded-lg shadow-lg">
          <div className="p-2 border-b border-slate-100 dark:border-[#3A3A3C] flex items-center gap-2">
            <Search className="w-4 h-4 text-slate-400" />
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari barang…"
              className="w-full text-sm outline-none focus:outline-none focus:ring-0 border-0 bg-transparent text-slate-900 dark:text-white"
              data-testid={testId ? `${testId}-search` : undefined} />
          </div>
          <div className="max-h-60 overflow-y-auto">
            {filtered.length === 0 && <div className="px-3 py-2 text-sm text-slate-400">Tidak ada hasil</div>}
            {filtered.slice(0, 300).map((o) => (
              <button key={o.value} type="button" onClick={() => { onValueChange(o.value); setOpen(false); setQ(""); }}
                className="w-full text-left px-3 py-2 text-sm hover:bg-slate-50 dark:hover:bg-white/10 flex items-center justify-between gap-2 text-slate-800 dark:text-slate-100"
                data-testid={testId ? `${testId}-opt-${o.value}` : undefined}>
                <span className="truncate">{o.label}</span>{o.value === value && <Check className="w-4 h-4 text-blue-600 shrink-0" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
